// extracted by mini-css-extract-plugin
export default {"heading_loading":"style_heading_loading__oUx+Z","loading_animation":"style_loading_animation__VK8qD","moving-gradient":"style_moving-gradient__+x4i8"};